import { SendMoneyValueLabel } from '@components/SendMoneyComponents'
import { format, isValid, parse } from 'date-fns'
import { tr } from 'mmfintech-commons'

const RECURRING_STEP_LABELS: Record<string, [string, string]> = {
  DAILY: ['FRONTEND.RECURRING.FREQUENCY_DETAILS.DAILY', 'Daily'],
  WEEKLY: ['FRONTEND.RECURRING.FREQUENCY_DETAILS.WEEKLY', 'Weekly'],
  BI_WEEKLY: ['FRONTEND.RECURRING.FREQUENCY_DETAILS.BI_WEEKLY', 'Biweekly'],
  MONTHLY: ['FRONTEND.RECURRING.FREQUENCY_DETAILS.MONTHLY', 'Monthly'],
  YEARLY: ['FRONTEND.RECURRING.FREQUENCY_DETAILS.YEARLY', 'Yearly']
}

const formatRecurringStep = (recurringStep: string) => {
  const label = RECURRING_STEP_LABELS[recurringStep]
  return label ? tr(label[0], label[1]) : recurringStep
}

export const RecurringPreviewRow = ({ formValues }) => {
  const { recurringPlanName, startDate, recurringStep } = formValues.prepare() || {}

  if (!startDate || !recurringStep) {
    return null
  }

  const parsedStartDate = parse(startDate, 'yyyy-MM-dd', new Date())

  return (
    <SendMoneyValueLabel
      label={tr('FRONTEND.WITHDRAW.BANK_TRANSFER.PREVIEW.RECURRING_TRANSFER', 'Recurring Transfer')}
      value={
        <div className='recurring-transfer-container'>
          <div>
            <b>{tr('FRONTEND.WITHDRAW.BANK_TRANSFER.PREVIEW.RECURRING_PAYMENT_NAME', 'Recurring Payment Name')}: </b>{' '}
            {recurringPlanName}
          </div>
          <div>
            <b>{tr('FRONTEND.RECURRING.FREQUENCY', 'Frequency')}: </b> {formatRecurringStep(recurringStep)}
          </div>
          <div>
            <b>{tr('FRONTEND.STAKING.TABLE.START_DATE_KEY', 'Start Date')}: </b>{' '}
            {isValid(parsedStartDate) ? format(parsedStartDate, 'dd MMMM yyyy') : startDate}
          </div>
        </div>
      }
      dataTest='recurring-transfer'
    />
  )
}
